function validatePhoneNumber(value: string): boolean {
  return /^[0-9-.()+\s]{10,20}$/.test(value);
}

export default validatePhoneNumber;
